import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCElRHSpzyMHaoUOCQyCWD9cgfSG1Qc5Zo",
  authDomain: "isthisbandai-2b719.firebaseapp.com",
  projectId: "isthisbandai-2b719",
  storageBucket: "isthisbandai-2b719.firebasestorage.app",
  messagingSenderId: "94169111127",
  appId: "1:94169111127:web:e7c29760d4135750d46112"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);